import { Component, OnInit } from '@angular/core';
import { App } from 'src/app/models/app';
import { ApplicationHubService } from 'src/app/services/application-hub.service';

@Component({
  selector: 'app-gateway',
  templateUrl: './gateway.component.html',
  styleUrls: ['./gateway.component.scss']
})
export class GatewayComponent implements OnInit {

  constructor(private service: ApplicationHubService) { }

  Applications: App[] = [];

  Filter: 'production' | 'test' = 'production';
  Production_Applications: App[] = [];
  Test_Applications: App[] = [];

  Loading = false;
  

  ngOnInit(): void {

    this.Loading = true;

    this.service.get().subscribe((data) => {
      this.Applications = data;
      this.Production_Applications = this.Applications.filter(x => x.Production);
      this.Test_Applications = this.Applications.filter(x => !x.Production);
    });

    this.Loading = false;
  }
}
